import parse from 'html-react-parser';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import AddEditModalComponent from 'molecules/AddToFavourite/Container/AddEditModalComponent';
import ReorderContainerGlobal from 'organisms/ReorderComponentGlobal/Container/ReorderContainer';
import Modal from 'molecules/Modal';
import { isCateringDisposition, isPickupDisposition } from 'common/utilities/utils';
import OrderSummaryInfoDetails from 'organisms/orderSummaryInfoDetails/container/orderSummaryInfoDetails';
import { REORDER_CONSTANTS } from 'common/constants/SharedConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
export const getAddEditFavouriteModal = params => {
  const { orderHistoryDetails, updateSetOrderHistoryDetails } = params;
  const { showFavoriteModal, orderHistory, selectedOrderId } = orderHistoryDetails;

  if (showFavoriteModal && selectedOrderId && orderHistory?.length) {
    const orderDetail = orderHistory?.find(details => details?.orderId === selectedOrderId);
    const { favoriteOrderName = '', orderId } = orderDetail;
    const getToasterMessage = () => {
      return parse(
        translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_ADDED_TO_FAVOURITE)?.replace(
          translateWithI18Next(TRANSLATE_MAPPING_KEY?.FAVOURITES),
          `<u>${translateWithI18Next(TRANSLATE_MAPPING_KEY?.FAVOURITES)}</u>`,
        ),
      );
    };
    return (
      <AddEditModalComponent
        showOccassionModal={showFavoriteModal}
        setOccassionModalOpen={() => updateSetOrderHistoryDetails({ showFavoriteModal: false })}
        occasionName={favoriteOrderName}
        setOccasionName={name => console.log(name)}
        cardInfo={{ id: orderId }}
        toastmessage={getToasterMessage()}
      />
    );
  }
  return null;
};

export const getReorderModal = params => {
  const { orderHistoryDetails } = params;
  const { orderHistory, selectedOrderId, openReorderModal, userOrderStateDispatch } = orderHistoryDetails;
  const { REORDER_MODAL_OPEN, FROM_REORDER_MODAL_OPEN, REORDER_STORE_CHANGED } = START_ORDER_CONSTANTS;

  if (openReorderModal && selectedOrderId && orderHistory?.length) {
    const orderDetail = orderHistory?.find(details => details?.orderId === selectedOrderId);
    const { service, orderId, store, deliveryAddress } = orderDetail;

    const closeButtonHandler = () => {
      userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
      userOrderStateDispatch({ type: REORDER_STORE_CHANGED, value: { storeChanged: false } });
      userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: false } });
    };

    return (
      <ReorderContainerGlobal
        currentOrderInfo={{ service, id: orderId, store, deliveryAddress }}
        reorderModalOpen={openReorderModal}
        //setReorderModalOpen={() => updateSetOrderHistoryDetails({ showReorderModal: false })}
        closeButtonHandler={closeButtonHandler}
        source={REORDER_CONSTANTS.ACCOUNT_ORDER_HISTORY}
      />
    );
  }
  return null;
};

export const getViewReceiptModal = params => {
  const { orderHistoryDetails, updateSetOrderHistoryDetails } = params;
  const {
    showViewReceiptModal,
    orderHistory,
    selectedOrderId,
    orderDetails,
    currencySymbol,
    currencyConversionFactor,
    showTaxLines,
    showTaxExcluded,
    enableClickCollectScheduleOrder, 
    allowScheduleOrderForDispositions, 
    enableScheduleOrder
  } = orderHistoryDetails;

  if (showViewReceiptModal && selectedOrderId && orderHistory?.length) {
    const viewReceiptModalProps = {
      id: 'orderHistoryViewReceiptModal',
      role: 'dialog',
      modalTitleId: 'orderHistoryViewReceiptModal',
      show: showViewReceiptModal,
      classNames: 'Base-modal order-History-view-receipt-modal',
      showCloseBtn: true,
      showBackBtn: false,
      closeButtonHandler: () => updateSetOrderHistoryDetails({ showViewReceiptModal: false }),
      modalTitle: translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_RECEIPT),
      closeDataTestId: 'orderHistoryViewReceiptCloseModal',
      autoFocus: true,
    };

    const updateSetOrderDetails = details => {
      updateSetOrderHistoryDetails({ orderDetails: { ...orderDetails, ...details } });
    };

    return (
      <Modal {...viewReceiptModalProps}>
        <div className='order-History-view-receipt-modal-container'>
          <OrderSummaryInfoDetails
            {...{
              orderDetails: {
                ...orderDetails,
                currencySymbol,
                currencyConversionFactor,
                enableClickCollectScheduleOrder, 
                allowScheduleOrderForDispositions, 
                enableScheduleOrder,
                showStoreDirectinPanelInOrderSummaryInfoDetails:
                  isPickupDisposition(orderDetails?.service) || isCateringDisposition(orderDetails?.service),
                showStoreHoursPanelInOrderSummaryInfoDetails: true,
                showTaxLines,
                showTaxExcluded,
              },
              updateSetOrderDetails,
            }}
          />
        </div>
      </Modal>
    );
  }
  return null;
};
